import { useLocalization } from "@fluent/react";
import { Table, Checkbox, Tooltip } from "@narmi/design_system";

type BulkReversalCheckboxCellProps = {
  isSelected: boolean;
  isSelectable: boolean;
  onToggle: () => void;
};

// eligible payments render an enabled checkbox. ineligible payments render a disabled checkbox
// with a Tooltip explaining why it cannot be reversed
// the disabled case adds the `bulk-reversal-checkbox-cell` class so the
// surrounding (overflow:hidden) table cell lets the tooltip overflow and wrap
// instead of clipping it (see BulkSelectReversalScreen.module.scss)
const BulkReversalCheckboxCell = ({
  isSelected,
  isSelectable,
  onToggle,
}: BulkReversalCheckboxCellProps) => {
  const { l10n } = useLocalization();

  return (
    <Table.Cell>
      {isSelectable ? (
        <div onClick={(e) => e.stopPropagation()}>
          <Checkbox
            kind="table"
            label={l10n.getString("bulk-reversal-select-payment-label")}
            checked={isSelected}
            onChange={onToggle}
          />
        </div>
      ) : (
        <div
          className="bulk-reversal-checkbox-cell"
          onClick={(e) => e.stopPropagation()}
        >
          <Tooltip
            side="top"
            maxWidth="240px"
            text={l10n.getString("bulk-reversal-ineligible-tooltip")}
          >
            <Checkbox
              kind="table"
              label={l10n.getString("bulk-reversal-select-payment-label")}
              isDisabled
              checked={false}
            />
          </Tooltip>
        </div>
      )}
    </Table.Cell>
  );
};

export default BulkReversalCheckboxCell;
